import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { fetchHiredlyXContent } from "../../../redux/actions/company_action";
import { GridStyledTagline, GridTagline, TaglineSubtitle } from "./styles";

let query = `
  taglineSection{
      title
      coverImage {
        data {
          attributes {
            url
          }
        }
      }
  }
`;

export default function HXTagline(props) {
  const { onScrollToPackage } = props;
  const [tagline, setTagline] = useState([]);

  const dispatch = useDispatch();

  async function fetchData() {
    const response = await dispatch(fetchHiredlyXContent(query));

    const { taglineSection } = response || {};

    setTagline(taglineSection);
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <GridStyledTagline
        backgroundImage={tagline?.[0]?.coverImage?.data?.attributes?.url}
      >
        {tagline?.slice(0, 1).map((tagline) => {
          return (
            <>
              <GridTagline>
                <TaglineSubtitle>{tagline?.title}</TaglineSubtitle>
              </GridTagline>
            </>
          );
        })}
      </GridStyledTagline>
    </>
  );
}
